import styled, { css } from 'styled-components';
import { themeColor, themeSpacing } from '../../utils';
const getVariantColor = () => ({ variant }) => {
    switch (variant) {
        case 'primary':
            return css `
        ${themeColor('primary', 'main')};
      `;
        case 'secondary':
            return css `
        ${themeColor('secondary', 'main')};
      `;
        default:
            return css `
        ${themeColor('tint', 'level7')};
      `;
    }
};
const RadioStyle = styled.input.attrs({
    type: 'radio',
}) `
  cursor: inherit;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 24px;
  height: 24px;
  left: 4px;
  top: 4px;
`;
export default RadioStyle;
const RadioCircleStyle = styled.span `
  width: 24px;
  height: 24px;
  color: ${themeColor('tint', 'level5')};
  background-color: ${themeColor('tint', 'level1')};
  border: 1px solid;
  border-radius: 50%;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    background-color: ${getVariantColor()};
    opacity: 0;
    z-index: 1;
    ${({ checked }) => checked &&
    css `
        opacity: 1;
      `}
  }

  ${({ error, checked, disabled, focus }) => error &&
    !checked &&
    !disabled &&
    !focus &&
    css `
      border-width: 2px;
      color: red;
    `}
`;
export { RadioCircleStyle };
const RadioWrapperStyle = styled.div `
  position: relative;
  display: inline-flex;
  user-select: none;
  vertical-align: middle;
  flex-shrink: 0; /* IE11 fix */
  padding: ${themeSpacing(1)};
  margin-bottom: 1px;
  margin-right: ${themeSpacing(2)};
  ${({ disabled }) => disabled &&
    css `
      pointer-events: none;
    `}

  ${({ checked, disabled, focus }) => !checked &&
    !disabled && // IE11 fix. If an element is disabled, you can still hover on it on IE11.
    !focus && // don't override the outline if element is also focussed
    css `
      &:hover ${RadioCircleStyle} {
        border: 2px solid;
        color: ${getVariantColor()};
      }
    `}
`;
export { RadioWrapperStyle };
//# sourceMappingURL=RadioStyle.js.map